<div class="main-container double-chat">
  <div class="top-bar d-flex justify-content-between align-items-center"></div>

  <div class="panes-container">
    <div class="pane pane-left">
      <div class="messages-container" #messagesContainer1>
        <div class="pinned-nav-top-right" *ngIf="pinnedMessages1.length > 0">
          <div class="pin-stack-anchor" (click)="$event.stopPropagation()">
            <button
              class="arrow prev"
              type="button"
              (click)="scrollToPinned(1, false); $event.stopPropagation()"
            >
              <i class="fas fa-arrow-up"></i>
            </button>

            <button
              class="arrow next"
              type="button"
              (click)="scrollToPinned(1, true); $event.stopPropagation()"
            >
              <i class="fas fa-arrow-down"></i>
            </button>

            <button type="button" class="pin-stack-pill" (click)="togglePinStack(1, $event)">
              📌 {{ pinnedMessages1.length }} pinned
            </button>

            <button
              type="button"
              class="pin-clear-btn"
              (click)="clearAllPins(1, $event)"
              aria-label="Clear all pins"
            >
              <i class="fas fa-xmark"></i>
            </button>

            <div class="pin-stack-preview" *ngIf="showPinStack1" (click)="$event.stopPropagation()">
              <div class="pin-stack-title">📌 {{ pinnedMessages1.length }} pinned</div>

              <button
                type="button"
                class="pin-stack-item"
                *ngFor="let pm of pinnedMessages1; trackBy: trackMsg"
                (click)="jumpToPinned(1, pm.id); $event.stopPropagation()"
              >
                <div class="pin-stack-snippet">{{ pm.content || '[no text]' }}</div>
                <div class="pin-stack-meta">
                  {{ messageTimestampModelLabel(pm) }}
                  <span *ngIf="pm.timestamp"> • {{ pm.timestamp | date: 'short' }}</span>
                </div>
              </button>
            </div>
          </div>
        </div>

        <div class="chat-placeholder-grid-container" *ngIf="currentMessagesModel1.length === 0 && !isLoading">
          <img
            *ngIf="hasVendorLogo(currentModel); else defaultLogo1"
            [src]="getVendorLogo(currentModel)"
            class="grid-item-logo vendor-logo"
            [class.circular-logo]="getVendorLogo(currentModel).includes('x5-baby')"
            [alt]="formatModelName(currentModel) + ' logo'"
          />

          <ng-template #defaultLogo1>
            <img src="assets/logos/iamclari2.png" class="grid-item-logo" />
          </ng-template>

          <h1 class="placeholder-title">
            <span class="model-name">{{ formatModelName(currentModel) }}&nbsp;</span>
          </h1>

          <h1 class="placeholder-subtitle bigal-sub ready-pill ready-pill--left scan">
            <span>#1 Model</span>
            <span class="ready-dot"></span>
            <span>Ready</span>
          </h1>
        </div>

        <div
          *ngFor="let message of currentMessagesModel1; let i = index; trackBy: trackMsg"
          class="message"
          [id]="'m1-msg-' + message.id"
          [ngClass]="{ 'user-message': message.role === 'user', 'assistant-message': message.role === 'assistant' }"
        >
          <button
            *ngIf="!message.pinned"
            type="button"
            class="pin-corner-btn"
            (click)="togglePinMessage(1, message, $event)"
            [attr.title]="'Pin message'"
          >
            <img src="assets/svg/pin.svg" height="20px" />
          </button>

          <button
            *ngIf="message.pinned"
            type="button"
            class="pin-corner-btn"
            (click)="togglePinMessage(1, message, $event)"
            [attr.title]="'Unpin message'"
          >
            <i class="fa-thumbtack fa-solid pinned"></i>
          </button>

          <div
            *ngIf="message.content"
            class="markdown prism-content"
            [innerHTML]="convertMarkdown(message.content)"
            appCodeHighlight
          ></div>

          <img
            *ngFor="let img of message.images || (message.image ? [message.image] : [])"
            [src]="img?.startsWith('http') || img?.startsWith('data:') ? img : 'data:image/jpeg;base64,' + img"
            class="ai-image mt-2 me-2"
            style="max-width: 100%; border-radius: 8px"
          />

          <div class="message-timestamp">
            {{ message.timestamp | date: 'short' }}
            <ng-container *ngIf="messageTimestampModelLabel(message) as tsModel">
              <span>— {{ tsModel }}</span>
            </ng-container>
            <span *ngIf="message.role === 'user'">— Yours Truly</span>

            <span class="actions-anchor" (click)="$event.stopPropagation()">
              <span
                class="action-toast anchored"
                *ngIf="message?.id && actionToastById[message.id]"
                [ngClass]="actionToastById[message.id].type"
              >
                {{ actionToastById[message.id].text }}
              </span>

              <button
                class="actions-plus-btn"
                type="button"
                (click)="toggleActionsMenu(message, $event)"
              >
                +
              </button>

              <div
                class="actions-dropdown anchored"
                *ngIf="isActionsMenuOpen(message)"
                (click)="$event.stopPropagation()"
              >
                <button type="button" class="actions-item" (click)="onActionPin(1, message, $event)">
                  <span class="me-2">{{ message.pinned ? '📌' : '🔖' }}</span>
                  {{ message.pinned ? 'Unpin' : 'Pin' }}
                </button>

                <button type="button" class="actions-item" (click)="onActionCopy(message, i, $event)">
                  <i class="fa-regular fa-copy me-2"></i>
                  Copy
                </button>

                <button
                  type="button"
                  class="actions-item"
                  (click)="onActionCopyToClariChat(message, $event)"
                >
                  <i class="fa-solid fa-arrow-up-right-from-square me-2"></i>
                  Add to ClariNotes
                </button>
              </div>

              <span
                class="action-toast anchored"
                *ngIf="message?.id && actionToastById[message.id]"
                [ngClass]="actionToastById[message.id].type"
              >
                {{ actionToastById[message.id].text }}
              </span>
            </span>
          </div>
        </div>

        <app-bird-loader *ngIf="isLoading" label="Thinking"></app-bird-loader>
      </div>

      <button
        *ngIf="showScrollToBottom1"
        class="scroll-to-bottom-btn within-pane left-pane"
        (click)="scrollToBottom1()"
      >
        ↓
      </button>
    </div>

    <div class="divider-line"></div>

    <div class="pane pane-right">
      <div class="messages-container" #messagesContainer2>
        <div class="pinned-nav-top-right" *ngIf="pinnedMessages2.length > 0">
          <div class="pin-stack-anchor" (click)="$event.stopPropagation()">
            <button
              class="arrow prev"
              type="button"
              (click)="scrollToPinned(2, false); $event.stopPropagation()"
            >
              <i class="fas fa-arrow-up"></i>
            </button>

            <button
              class="arrow next"
              type="button"
              (click)="scrollToPinned(2, true); $event.stopPropagation()"
            >
              <i class="fas fa-arrow-down"></i>
            </button>

            <button type="button" class="pin-stack-pill" (click)="togglePinStack(2, $event)">
              📌 {{ pinnedMessages2.length }} pinned
            </button>

            <button
              type="button"
              class="pin-clear-btn"
              (click)="clearAllPins(2, $event)"
              aria-label="Clear all pins"
            >
              <i class="fas fa-xmark"></i>
            </button>

            <div class="pin-stack-preview" *ngIf="showPinStack2" (click)="$event.stopPropagation()">
              <div class="pin-stack-title">📌 {{ pinnedMessages2.length }} pinned</div>

              <button
                type="button"
                class="pin-stack-item"
                *ngFor="let pm of pinnedMessages2; trackBy: trackMsg"
                (click)="jumpToPinned(2, pm.id); $event.stopPropagation()"
              >
                <div class="pin-stack-snippet">{{ pm.content || '[no text]' }}</div>
                <div class="pin-stack-meta">
                  {{ messageTimestampModelLabel(pm) }}
                  <span *ngIf="pm.timestamp"> • {{ pm.timestamp | date: 'short' }}</span>
                </div>
              </button>
            </div>
          </div>
        </div>

        <div class="chat-placeholder-grid-container" *ngIf="currentMessagesModel2.length === 0 && !isLoading">
          <img
            *ngIf="hasVendorLogo(currentModel2); else defaultLogo2"
            [src]="getVendorLogo(currentModel2)"
            class="grid-item-logo vendor-logo"
            [class.circular-logo]="getVendorLogo(currentModel2).includes('x5-baby')"
            [alt]="formatModelName(currentModel2) + ' logo'"
          />

          <ng-template #defaultLogo2>
            <img src="assets/logos/iamclari2.png" class="grid-item-logo" />
          </ng-template>

          <h1 class="placeholder-title">
            <span class="model-name">{{ formatModelName(currentModel2) }}&nbsp;</span>
          </h1>

          <h1 class="placeholder-subtitle bigal-sub ready-pill ready-pill--right scan">
            <span>#2 Model</span>
            <span class="ready-dot"></span>
            <span>Ready</span>
          </h1>
        </div>

        <div
          *ngFor="let message of currentMessagesModel2; let i = index; trackBy: trackMsg"
          class="message"
          [id]="'m2-msg-' + message.id"
          [ngClass]="{ 'user-message': message.role === 'user', 'assistant-message': message.role === 'assistant' }"
        >
          <button
            *ngIf="!message.pinned"
            type="button"
            class="pin-corner-btn"
            (click)="togglePinMessage(2, message, $event)"
            [attr.title]="'Pin message'"
          >
            <img src="assets/svg/pin.svg" height="25px" />
          </button>

          <button
            *ngIf="message.pinned"
            type="button"
            class="pin-corner-btn"
            (click)="togglePinMessage(2, message, $event)"
            [attr.title]="'Unpin message'"
          >
            <i class="fa-thumbtack fa-solid pinned"></i>
          </button>

          <div
            *ngIf="message.content"
            class="markdown prism-content"
            [innerHTML]="convertMarkdown(message.content)"
            appCodeHighlight
          ></div>

          <img
            *ngFor="let img of message.images || (message.image ? [message.image] : [])"
            [src]="img?.startsWith('http') || img?.startsWith('data:') ? img : 'data:image/jpeg;base64,' + img"
            class="ai-image mt-2 me-2"
            style="max-width: 100%; border-radius: 8px"
          />

          <div class="message-timestamp">
            {{ message.timestamp | date: 'short' }}
            <ng-container *ngIf="messageTimestampModelLabel(message) as tsModel">
              <span>— {{ tsModel }}</span>
            </ng-container>
            <span *ngIf="message.role === 'user'">— Yours Truly</span>

            <span class="actions-anchor" (click)="$event.stopPropagation()">
              <span
                class="action-toast anchored"
                *ngIf="message?.id && actionToastById[message.id]"
                [ngClass]="actionToastById[message.id].type"
              >
                {{ actionToastById[message.id].text }}
              </span>

              <button
                class="actions-plus-btn"
                type="button"
                (click)="toggleActionsMenu(message, $event)"
              >
                +
              </button>

              <div
                class="actions-dropdown anchored"
                *ngIf="isActionsMenuOpen(message)"
                (click)="$event.stopPropagation()"
              >
                <button type="button" class="actions-item" (click)="onActionPin(2, message, $event)">
                  <span class="me-2">{{ message.pinned ? '📌' : '🔖' }}</span>
                  {{ message.pinned ? 'Unpin' : 'Pin' }}
                </button>

                <button type="button" class="actions-item" (click)="onActionCopy(message, i, $event)">
                  <i class="fa-regular fa-copy me-2"></i>
                  Copy
                </button>

                <button
                  type="button"
                  class="actions-item"
                  (click)="onActionCopyToClariChat(message, $event)"
                >
                  <i class="fa-solid fa-arrow-up-right-from-square me-2"></i>
                  Add to ClariNotes
                </button>
              </div>

              <span
                class="action-toast anchored"
                *ngIf="message?.id && actionToastById[message.id]"
                [ngClass]="actionToastById[message.id].type"
              >
                {{ actionToastById[message.id].text }}
              </span>
            </span>
          </div>
        </div>

        <app-bird-loader *ngIf="isLoading" label="Thinking"></app-bird-loader>
      </div>

      <button
        *ngIf="showScrollToBottom2"
        class="scroll-to-bottom-btn within-pane right-pane"
        (click)="scrollToBottom2()"
      >
        ↓
      </button>
    </div>
  </div>

  <!-- Mobile-only notice for small screens -->
  <div class="doublechat-mobile-warning">
    <img
      src="assets/illustrations/coming-soon-features.svg"
      alt="Coming soon"
      class="doublechat-mobile-warning__image"
    />
    <p class="doublechat-mobile-warning__text">
      Sorry this feature is only available on screens above 1000px.
    </p>
  </div>

  <!-- Desktop composer (hidden on screens below 1000px) -->
  <div class="bottomcontainer doublechat-desktop-composer">
    <div class="input-container">
      <div class="composer-shell">
        <div class="textarea-wrapper">
         <textarea
  #chatTextarea
  id="chatInputTextarea"
  class="user-input-textarea"
  [(ngModel)]="userInput"
  rows="1"
  (input)="autoResize(chatTextarea)"
  [placeholder]="isFocused ? '' : composerPlaceholderText"
  (focus)="onTextareaFocus()"
  (blur)="onTextareaBlur()"
  (keydown)="onKeyDown($event)"
  [disabled]="isLoading || audioActive"
  [class.disabled-typing]="audioActive">
</textarea>

          <div class="left-actions">
            <div class="composer-tools">
              <button
                type="button"
                class="tools-plus-btn"
                aria-label="Open AI model menu"
                (click)="openModelSelectionDialog(); $event.stopPropagation()"
              >
                <span class="tools-plus-icon" aria-hidden="true">+</span>
              </button>

            </div>
          </div>

          <button
            *ngIf="userInput?.trim()?.length"
            id="sendMessageButton"
            class="btn-send-fixed"
            type="button"
            (click)="sendMessage()"
            [disabled]="isLoading || !userInput?.trim()?.length"
          >
            <i class="fas fa-arrow-up send-arrow-icon" aria-hidden="true"></i>
          </button>

          <div class="model-grid-inside">
            <div class="grid-item-inside selector">
              <button id="aiCatalogBtn" class="elegant-btn" (click)="openModelSelectionDialog()">
                <span class="btn-text">AI Menu</span>
                <i class="fas fa-chevron-down btn-chevron"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <button
    type="button"
    class="coach-fab"
    [disabled]="coachFabBusy"
    (click)="triggerCoachFab()"
    aria-label="Invoke AI Coach"
  >
    <i class="fa-solid fa-brain" aria-hidden="true"></i>
    <span>{{ coachFabText }}</span>
  </button>
</div>
